'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Viewport = require('./Viewport');

var _Viewport2 = _interopRequireDefault(_Viewport);

var _DragArea = require('./DragArea');

var _DragArea2 = _interopRequireDefault(_DragArea);

var _reactMotion = require('react-motion');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/* injects from baggage-loader */

var SPRING_CONFIG = [800, 80];
var SPRING_SOFT_CONFIG = [120, 20];

var DraggableViewport = function (_Component) {
  _inherits(DraggableViewport, _Component);

  function DraggableViewport(props) {
    _classCallCheck(this, DraggableViewport);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DraggableViewport).call(this, props));

    _this.state = {
      dragging: false,
      x: props.initSceneX || 0,
      y: props.initSceneY || 0
    };

    return _this;
  }

  _createClass(DraggableViewport, [{
    key: 'handleDragStart',
    value: function handleDragStart() {
      this.setState({ dragging: true });
      this.props.onDragStart();
    }
  }, {
    key: 'handleDrag',
    value: function handleDrag(_ref) {
      var x = _ref.x;
      var y = _ref.y;

      this.setState({ x: x, y: y });
    }
  }, {
    key: 'onPositionChange',
    value: function onPositionChange(pos) {
      if (this.props.sendPositionChange && this.props.onPositionChange) this.props.onPositionChange(pos);
    }
  }, {
    key: 'handleDragStop',
    value: function handleDragStop() {
      var _state = this.state;
      var x = _state.x;
      var y = _state.y;

      this.setState({ dragging: false });
      this.onPositionChange({ x: x, y: y });
      this.props.onDragStop();
    }
  }, {
    key: 'getPosition',
    value: function getPosition() {
      var _state2 = this.state;
      var x = _state2.x;
      var y = _state2.y;

      return { x: x, y: y };
    }
  }, {
    key: 'getSpringConfig',
    value: function getSpringConfig() {
      if (this.state.dragging) {
        return SPRING_CONFIG;
      }
      return SPRING_SOFT_CONFIG;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state3 = this.state;
      var x = _state3.x;
      var y = _state3.y;
      var _props = this.props;
      var initSceneX = _props.initSceneX;
      var initSceneY = _props.initSceneY;


      var springConfig = this.getSpringConfig();

      return _react2.default.createElement(
        _DragArea2.default,
        {
          initX: initSceneX,
          initY: initSceneY,
          onDrag: this.handleDrag.bind(this),
          onDragStop: this.handleDragStop.bind(this),
          onDragStart: this.handleDragStart.bind(this),
          preventDefault: true,
          reversed: true
        },
        _react2.default.createElement(
          _reactMotion.Motion,
          { defaultStyle: { x: initSceneX, y: initSceneY },
            style: { x: (0, _reactMotion.spring)(x, springConfig), y: (0, _reactMotion.spring)(y, springConfig) } },
          function (value) {
            return _react2.default.createElement(
              _Viewport2.default,
              { x: Math.round(value.x), y: Math.round(value.y) /* truncate coords for svg rendering */ },
              _this2.props.children
            );
          }
        )
      );
    }
  }]);

  return DraggableViewport;
}(_react.Component);

exports.default = DraggableViewport;


DraggableViewport.propTypes = {
  initSceneX: _react.PropTypes.number.isRequired,
  initSceneY: _react.PropTypes.number.isRequired,
  children: _react.PropTypes.any.isRequired,
  soft: _react.PropTypes.bool,
  sendPositionChange: _react.PropTypes.bool,

  onPositionChange: _react.PropTypes.func,

  onDragStart: _react.PropTypes.func.isRequired,
  onDragStop: _react.PropTypes.func.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectView/Viewport/DraggableViewport.js
// module id = 603
// module chunks = 1